// —————————————————————————————————————————————————————————————————————— TOGGLE
const buttons = document.querySelectorAll('a.button.toggle')

buttons.forEach(button => {
  button.addEventListener('click', () => {
    if (button.classList.contains('active')) {
      return
    } else {
      buttons.forEach(button => {
        button.classList.remove('active')
      })
      button.classList.add('active')
    }
  })
})

// —————————————————————————————————————————————————————————————————————— QUANTITY
const quantityButtons = document.querySelectorAll('.button.quantity')

quantityButtons.forEach(button => {
  let value = 1
  let max = parseInt(button.dataset.max)
  const valueTag = document.querySelector('.quantityInput')
  const up = button.querySelector('#more')
  const down = button.querySelector('#less')

  
  function changeValue(value) {
   
    if (value <= 1) {
      value = 1
      down.style.opacity = 0.25;
      down.style.cursor = 'not-allowed'
    }
    if (value >= max) {
      value = max
      up.style.opacity = 0.25;
      up.style.cursor = 'not-allowed';
    }
    if (value > 1) { 
      down.style.opacity = 1;
      down.style.cursor = 'pointer';
                   }
    if (value < max) { 
      up.style.opacity = 1; 
      up.style.cursor = 'pointer';
    }

    return value
  }

  up.addEventListener('click', () => {
    changeValue(valueTag.value)
  })
  down.addEventListener('click', () => {
    changeValue(valueTag.value)
  })
})

// —————————————————————————————————————————————————————————————————————— CART
const cartButtons = document.querySelectorAll('.button.cart')

cartButtons.forEach(button => {
  button.addEventListener('click', () => {
    button.classList.add('active')
    button.innerHTML = 'Adding...'
    setTimeout(() => {
      button.innerHTML = 'Added to cart'
      button.style.transition = 'var(--transLong)'
      setTimeout(() => {
        button.classList.remove('active')
        button.innerHTML = '+ Add to cart'
        setTimeout(() => { button.style.transition = 'var(--transShort)' }, 500) 
      }, 4000) 
    }, 2000)    
  })
})